import styled from 'styled-components';
import { OCardFeatureContentAlignment, OCardFeatureLayout } from './OCardFeature.types';
import { baseVariables } from '../../styles';

export const CardFeatureWrapper = styled.div<{
  $contentAlignment?: string;
  $layout?: string;
}>`
  display: flex;
  flex-direction: column;
  width: 100%;
  background-color: var(--t-brand-bg-color);
  color: var(--t-brand-fg-color);

  @media ${baseVariables.mediaQuery.md} {
    flex-direction: ${({ $layout }) => ($layout === OCardFeatureLayout.Reverse ? 'row-reverse' : 'row')};
    gap: 2rem;
  }

  @media ${baseVariables.mediaQuery.lg} {
    gap: 3rem;
  }
`;

export const MediaContainer = styled.div<{
  $layout?: string;
}>`
  width: 100%;
  flex-shrink: 0;
  margin-block-end: 1.5rem;

  @media ${baseVariables.mediaQuery.md} {
    width: 50%;
    margin-block-end: 0;
  }

  .o-card-feature__media {
    width: 100%;
    height: 100%;
    min-height: 300px;

    @media ${baseVariables.mediaQuery.md} {
      min-height: 400px;
    }

    @media ${baseVariables.mediaQuery.lg} {
      min-height: 500px;
    }
  }
`;

export const ContentContainer = styled.div<{
  $contentAlignment?: string;
  $layout?: string;
}>`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  padding-inline: 1rem;
  padding-block: 1rem;

  ${({ $contentAlignment }) =>
    $contentAlignment === OCardFeatureContentAlignment.Centered &&
    `
    align-items: center;
    text-align: center;
  `}

  @media ${baseVariables.mediaQuery.md} {
    width: 50%;
    padding-inline: 1.5rem;
    padding-block: 2rem;
  }

  @media ${baseVariables.mediaQuery.lg} {
    padding-inline: 2rem;
    padding-block: 3rem;
  }
`;

export const TextBlockWrapper = styled.div`
  margin-block-end: 1.5rem;

  .o-card-feature__text-block {
    width: 100%;
  }

  @media ${baseVariables.mediaQuery.md} {
    margin-block-end: 2rem;
  }
`;

export const ButtonGroup = styled.div<{
  $contentAlignment?: string;
}>`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  width: 100%;

  ${({ $contentAlignment }) =>
    $contentAlignment === OCardFeatureContentAlignment.Centered &&
    `
    align-items: center;
  `}

  @media ${baseVariables.mediaQuery.sm} {
    flex-direction: row;
    flex-wrap: wrap;
  }

  @media ${baseVariables.mediaQuery.md} {
    gap: 1.5rem;
  }
`;

export const ButtonWrapper = styled.div`
  .o-card-feature__button-primary,
  .o-card-feature__button-secondary {
    width: 100%;

    @media ${baseVariables.mediaQuery.sm} {
      width: auto;
    }
  }
`;
